import React from 'react';

import { Card } from 'react-bootstrap-5';

interface Props {
  children: React.ReactNode;
  control?: React.ReactNode;
  header: string;
}

export default function OptionsCard({ children, control, header }: Props) {
  return (
    <Card className="w-100">
      <Card.Header className="d-flex justify-content-between align-items-center gap-2">
        <h6>{header}</h6>
        {control}
      </Card.Header>

      <Card.Body className="overflow-y-auto">
        {children}
      </Card.Body>
    </Card>
  );
}
